import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import Reveal from "@/components/Reveal";
import { PROJECTS } from "@/data/site";

export default function PortfolioBento() {
  return (
    <section
      className="relative py-24 md:py-32"
      data-testid="portfolio-section"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div>
            <Reveal>
              <span className="eyebrow">Selected work</span>
            </Reveal>
            <Reveal delay={0.1}>
              <h2 className="font-display font-black uppercase tracking-tighter leading-[0.9] text-5xl md:text-6xl lg:text-7xl mt-5">
                Receipts. <br />
                <span className="text-stroke">Not promises.</span>
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.18}>
            <Link
              to="/work"
              className="btn-ghost"
              data-testid="portfolio-view-all"
            >
              View all work <ArrowUpRight className="h-4 w-4" />
            </Link>
          </Reveal>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          {PROJECTS.slice(0, 4).map((p, i) => (
            <Reveal
              key={p.id}
              delay={i * 0.06}
              className={`bento-card group ${p.span} ${
                i === 0 ? "min-h-[480px]" : "min-h-[380px]"
              }`}
            >
              <Link
                to="/work"
                className="block relative h-full w-full"
                data-testid={`portfolio-card-${p.id}`}
              >
                <div className="absolute inset-0">
                  <img
                    src={p.image}
                    alt={p.name}
                    className="bento-img h-full w-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent" />
                </div>

                <div className="relative h-full p-6 md:p-8 flex flex-col justify-between">
                  <div className="flex items-start justify-between">
                    <div className="flex flex-wrap gap-2">
                      {p.tags.map((t) => (
                        <span key={t} className="float-tag bg-black/40">
                          {t}
                        </span>
                      ))}
                    </div>
                    <span className="font-mono text-xs text-white/60">
                      {p.year}
                    </span>
                  </div>

                  <div>
                    <div className="text-xs uppercase tracking-[0.24em] text-white/55 mb-2">
                      {p.sector}
                    </div>
                    <h3 className="font-display text-3xl md:text-5xl font-bold uppercase tracking-tight leading-none">
                      {p.name}
                    </h3>
                    <p className="text-white/75 mt-3 max-w-md">{p.blurb}</p>

                    <div className="mt-5 inline-flex items-center gap-2 text-sm uppercase tracking-[0.18em] text-[#FF4500] font-semibold">
                      Case study <ArrowUpRight className="h-4 w-4" />
                    </div>
                  </div>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
